import { createContext, useContext, useLayoutEffect } from "react";

export interface LoadGateApi {
  setItem: (key: string, pending: boolean) => void;
  removeItem: (key: string) => void;
}

// Os contextos moram aqui, e não no Provider (.tsx), para o arquivo do componente exportar só componente.
export const LoadGateApiContext = createContext<LoadGateApi | null>(null);
export const LoadGateReadyContext = createContext(true);

/**
 * Declara um item de carga. Fora do provedor não faz nada, para as seções
 * continuarem testáveis isoladas.
 */
export function useDetailLoadItem(key: string, pending: boolean) {
  const gate = useContext(LoadGateApiContext);

  useLayoutEffect(() => {
    if (!gate) return;
    gate.setItem(key, pending);
  }, [gate, key, pending]);

  useLayoutEffect(() => {
    if (!gate) return;
    return () => gate.removeItem(key);
  }, [gate, key]);
}

/** `true` quando não há provedor: o botão não fica preso fora do detalhamento. */
export function useDetailContentReady(): boolean {
  return useContext(LoadGateReadyContext);
}
